import React from "react";
import ProcedureProcessFileThead from "../../approveAndReviseFileHeadFields";
import { fileTags } from "../../../../../publicDictionaryValues";
import BaseFileTable from "../../../../../commonComponents/fileTables/baseFileTable";
import ApplyJbFileTbody from "../../../../applyForJbSection/fields/fileTable/applyJbFileBody";

export default class ApproveApplyJbTable extends BaseFileTable {
  constructor(props: any) {
    super(props);
    this.state = {
      data: [],
      columns: this.props.columns,
      isExpendData: false,
      isExpendNote: false,
      expendHeight: 40,
      isTableBorderError: this.props.isTableBorderError,
    };
    // @ts-ignore
    this.approveNumber = 0;
  }

  setNeedApproveDataNumber = (data: any) => {
    // @ts-ignore
    this.approveNumber = 0;
    for (let index in data) {
      const status = data[index].data.find((i: any) => i.name === "status").value;
      const applyForValue = data[index].data.find((item: any) => item.name === "applyfor").value;
      if ((status === null || status === "") && applyForValue === "JB") {
        // @ts-ignore
        this.approveNumber += 1;
      }
    }
  };

  render() {
    const {
      procedureNoteMaxLength,
      procedureNoteSize,
      inputOnChange,
      fileTableRef,
      className,
      optionList,
      isShowReturnReason,
      handleReturnClick,
      handleFileSelect,
      currentRole,
      downloadFile,
      isComplete,
      columns,
      isExpendData,
      readOnly = false,
      isApproveCompletePage,
      isSubmitCompletePage,
      isTeminationCompletePage,
    } = this.props;
    const { data } = this.state;
    this.setNeedApproveDataNumber(data);
    return (
      <>
        <div className="scrollTable">
          <table className={`${className} table autoHeightChangeContainer`}>
            <ProcedureProcessFileThead columns={columns} />
            <ApplyJbFileTbody
              data={data}
              columns={columns}
              inputOnChange={inputOnChange}
              procedureNoteMaxLength={procedureNoteMaxLength}
              procedureNoteSize={procedureNoteSize}
              fileTableRef={fileTableRef}
              optionList={optionList}
              isShowReturnReason={isShowReturnReason}
              handleReturnClick={handleReturnClick}
              handleFileSelect={handleFileSelect}
              currentRole={currentRole}
              downloadFile={downloadFile}
              isComplete={isComplete}
              isExpendData={isExpendData}
            />
          </table>
        </div>
        {(!readOnly || isApproveCompletePage) && (
          <p className={`${this.props.className} fileNumTip`} style={{ color: "#FF9921" }}>
            {/* @ts-ignore */}
            <span className="fileNum">
              {isApproveCompletePage && !isTeminationCompletePage ? 0 : this.approveNumber}
            </span>{" "}
            {/* @ts-ignore */}
            {this.setFileText(
              isApproveCompletePage && !isTeminationCompletePage ? 0 : this.approveNumber
            )}{" "}
            pending approval
          </p>
        )}
        {isSubmitCompletePage && (
          <p className="fileNumTip" style={{ color: "#333" }}>
            <span className="fileNum">{data.length}</span> {this.setFileText(data.length)} in total
          </p>
        )}
      </>
    );
  }
}
